import React from 'react';
import PropTypes from 'prop-types';
import CommonStrings from 'resources/common-strings';
import CommonValues from 'resources/common-values';
import CreateReactClass from 'create-react-class';
import ComparisonUtils from 'components/student-profile/modules/comparisons/utils';
import NoPeriodDescription from '../../no-comparisons-period-message';

export default CreateReactClass({
    displayName: 'ComparisonsExpandedConditionalGrowth',

    propTypes: {
        subjectBid: PropTypes.number.isRequired,
        studentBid: PropTypes.string.isRequired,
        studentFirstName: PropTypes.string.isRequired,
        studentGender: PropTypes.string.isRequired,
        conditionalGrowthIndex: PropTypes.number,
        predictedGrowth: PropTypes.number,
        observedGrowth: PropTypes.number,
    },

    getConditonalGrowthDescription() {
        let description = '';

        if (this.props.conditionalGrowthIndex) {
            const displayedValue = ComparisonUtils.precisionRound(this.props.conditionalGrowthIndex, 2);

            const studentConditionalGrowthDescriptor =
                displayedValue > 0
                    ? CommonStrings.studentConditionalGrowthDescriptor.moreThan
                    : displayedValue < 0
                    ? CommonStrings.studentConditionalGrowthDescriptor.lessThan
                    : CommonStrings.studentConditionalGrowthDescriptor.equal;

            description = CommonStrings.getConditionalGrowthDescription(
                this.props.studentFirstName,
                studentConditionalGrowthDescriptor
            );
        }
        return description;
    },

    renderConditionalGrowth(subjectName) {
        const getGrowthDisplayVal = (growthVal) => {
            return growthVal === null
                ? CommonStrings.comparisonsGrowthNoResult
                : growthVal > 0
                ? '+' + growthVal.toFixed(0)
                : growthVal.toFixed(0);
        };

        const getGrowthDisplayClass = (growthVal) => {
            return growthVal !== null && growthVal < 0 ? 'growth-display-value minus' : 'growth-display-value';
        };

        const observedGrowthDisplayValue = getGrowthDisplayVal(this.props.observedGrowth);
        const projectedGrowthDisplayValue = getGrowthDisplayVal(this.props.predictedGrowth);

        const observedGrowthClassName = getGrowthDisplayClass(this.props.observedGrowth);
        const projectedGrowthClassName = getGrowthDisplayClass(this.props.predictedGrowth);

        const conditionalGrowthIndexDisplayValue = this.props.conditionalGrowthIndex
            ? ComparisonUtils.precisionRound(this.props.conditionalGrowthIndex, 2).toFixed(2)
            : CommonStrings.comparisonsGrowthNoResult;

        return (
            <div
                className="conditional-growth-module-content"
                id={`comparisons-conditional-growth-expanded-content-${subjectName}-${this.props.studentBid}`}
                style={{ paddingLeft: '1rem' }}
            >
                <div className="conditional-growth-index-container">
                    <div
                        className="conditional-growth-index-value"
                        id={`comparisons-conditional-growth-expanded-index-value-${subjectName}-${this.props.studentBid}`}
                    >
                        {conditionalGrowthIndexDisplayValue}
                    </div>
                    <div
                        className="conditional-growth-index-text"
                        id={`comparisons-conditional-growth-expanded-index-text-${subjectName}-${this.props.studentBid}`}
                    >
                        {CommonStrings.comparisonsConditionalGrowthIndex}
                    </div>
                </div>

                {this.props.conditionalGrowthIndex ? (
                    <div
                        className="conditional-growth-index-description"
                        id={`comparisons-conditional-growth-expanded-description-${subjectName}-${this.props.studentBid}`}
                    >
                        {this.getConditonalGrowthDescription()}
                    </div>
                ) : (
                    <NoPeriodDescription
                        id={`comparisons-conditional-growth-expanded-description-${subjectName}-${this.props.studentBid}`}
                        key="no-comparison-periods-message"
                        className="conditional-growth-index-description"
                        adjustOverflow={true}
                    />
                )}
                <div
                    className="conditional-growth-index-link"
                    id={`comparisons-conditional-growth-expanded-link-${subjectName}-${this.props.studentBid}`}
                >
                    <a
                        href={CommonStrings.comparisonsConditionalGrowthLink.target}
                        target="_blank"
                        key="conditional-growth-link"
                    >
                        {CommonStrings.comparisonsConditionalGrowthLink.displayText}
                    </a>
                </div>
                <div className="actual-growth-container">
                    <div className="growth-display projected">
                        <div className="projected-growth-description">Projected Growth</div>
                        <div>
                            <span
                                className={projectedGrowthClassName}
                                id={`comparisons-conditional-growth-expanded-projected-value-${subjectName}-${this.props.studentBid}`}
                            >
                                {projectedGrowthDisplayValue}
                            </span>
                            <span>{CommonStrings.rit}</span>
                        </div>
                        <div className="growth-display-term">{CommonStrings.comparisonsGrowthFromStartOfTerm}</div>
                    </div>
                    <div className="growth-display observed">
                        <div className="observed-growth-description">Observed Growth</div>
                        <div>
                            <span
                                className={observedGrowthClassName}
                                id={`comparisons-conditional-growth-expanded-observed-value-${subjectName}-${this.props.studentBid}`}
                            >
                                {observedGrowthDisplayValue}
                            </span>
                            <span>{CommonStrings.rit}</span>
                        </div>
                        <div className="growth-display-term">{CommonStrings.comparisonsGrowthTermEnd}</div>
                    </div>
                </div>
            </div>
        );
    },

    render() {
        const subjectName = CommonValues.getSubjectFieldforBid(this.props.subjectBid, 'shortName');
        return (
            <div
                className="growth-and-achievement-expanded-module conditional-growth"
                id={`comparisons-growth-and-achievement-expanded-${subjectName}-${this.props.studentBid}-conditional-growth`}
                style={{ width: '28%' }}
            >
                <h3 className="comparisons-expanded-module-heading">Conditional Growth</h3>
                <div className="comparisons-expanded-module">{this.renderConditionalGrowth(subjectName)}</div>
            </div>
        );
    },
});
